import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-14 md:py-20 px-4 sm:px-6 lg:px-8 bg-navy-800" data-id="element-107">
      <div className="max-w-4xl mx-auto" data-id="element-108">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-navy-700 to-navy-900 border border-navy-600 rounded-3xl p-6 md:p-8 md:p-12 text-center relative overflow-hidden" data-id="element-109">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-blue-500/5 blur-3xl pointer-events-none" data-id="element-110" />

          <div className="relative z-10" data-id="element-111">
            <ShieldCheck className="w-20 h-20 text-blue-400 mx-auto mb-6" data-id="element-112" />

            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-113">
              GARANTÍA TOTAL DE 7 DÍAS
            </h2>

            <p className="text-xl text-slate-300 mb-8 max-w-2xl mx-auto" data-id="element-114">
              Probalo durante 7 días completos.
              <br data-id="element-115" />
              <br data-id="element-116" />
              Si no es para tu familia:
              <br data-id="element-117" />
              <span className="text-white font-bold text-2xl block mt-2" data-id="element-118">
                devolución 100%
              </span>
              <span className="text-blue-300 font-medium" data-id="element-119">
                Sin preguntas. Sin riesgo.
              </span>
            </p>

            <div className="inline-block bg-navy-900/80 px-6 py-3 rounded-full border border-navy-600 text-sm font-medium text-slate-400" data-id="element-120">
              Tasa de devoluciones: menos del 1%.
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}